



import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { ProductForProductPageType } from '~/utils/types/ProductPage';

import BundlePurchaseOptionCard from '../../ProductPage/PurchaseOptions/BundlePurchaseOptionCard.vue';

export default defineComponent({
    props: {
        product: {
            type:  Object as PropType<ProductForProductPageType>,
            required: true
        },
        useCarousel:{
            type:Boolean,
            default:false
        }
    },
    components:{
        BundlePurchaseOptionCard
    }
})
